// import { createBrowserHistory } from "history";
// export const history = createBrowserHistory();

import {createHashHistory} from 'history';
export const history = createHashHistory();
